<template>
  <div class="notFound">
    <h1 class="header">404</h1>
    <h2>Page not found</h2>
    <p>Sorry, the page you are looking for could not be found.</p>
    <router-link class="homeLink" to="/">Go to Home</router-link>
  </div>
</template>

<script>
export default {}
</script>

<style src="../../assets/css/views/Error/NotFoundView.css" scoped></style>
